export default __webpack_public_path__ + "static/media/device.169251df.svg";